import { configureStore } from "@reduxjs/toolkit";
import countryCodeReducer from "../Reducers/CountryCodesSlice";
import analysisReducer from "../Reducers/analysisSlice";
import contactReducer from "../Reducers/ContactSlice";
import signupReducer from "../Reducers/SignupSlice";
import loginReducer from "../Reducers/LoginSlice";
import generalInfoReducer from "../Reducers/GeneralInfoSlice";
import dashboardReducer from "../Reducers/DashboardSlice";
import diabetesReducer from "../Reducers/DiabetesSlice";
import gMapReducer from "../Reducers/GoogleMapSlice";
import storage from "redux-persist/lib/storage";
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";

const persistConfig = {
  key: "user_login",
  storage,
};

const persistedReducer = persistReducer(persistConfig, loginReducer);

const Store = configureStore({
  reducer: {
    countryCodes: countryCodeReducer,
    contact: contactReducer,
    signup: signupReducer,
    login: persistedReducer,
    generalInfo: generalInfoReducer,
    dashboard: dashboardReducer,
    diabetes: diabetesReducer,
    gmap: gMapReducer,
    analysis: analysisReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER], 
      },
    }),
});

export const persistor = persistStore(Store);
export default Store;
